function handleCCOption() {
  $("#zonewidget .container").trigger("MR_RebindMap");
// Mondial Relay Code Starts
  $(document).ready(function () {
    $('#storeInfo').val();
	var islgscreen = false;
    if ($(window).width() > 798) {	
		islgscreen = true;
    }
	$('[data-remodal-id=zonewidget]').remodal().open();
  // Charge le widget dans la DIV d'id "Zone_Widget" avec les paramètres indiqués 
  // et renverra le Point Relais sélectionné par l'utilisateur dans le champs d'ID "Retour_Widget"
  $("#zonewidget .container").MR_ParcelShopPicker({ 
    Target: "#Retour_Widget", // Selecteur JQuery de l'élément dans lequel sera renvoyé l'ID du Point Relais sélectionné (généralement un champ input hidden)
    //
    // Paramétrage du widget pour obtention des point relais.
    //
    // Le code client Mondial Relay, sur 8 caractères (ajouter des espaces à droite)
    // BDTEST est utilisé pour les tests => un message d'avertissement apparaît
    Brand: "BDTEST  ",
    // Nombre de Point Relais à afficher
    NbResults: "10",
    // Pays utilisé pour la recherche: code ISO 2 lettres.
    Country: "FR",
    AllowedCountries: "FR,BE", 
    // Code postal pour lancer une recherche par défaut
    PostCode: "75001",
    // Mode de livraison (Standard [24R], XL [24L], XXL [24X], Drive [DRI])
    ColLivMod: "24R",
    //
    // Paramétrage d'affichage du widget.
    //
    // Activer l'affichage Responsive.
    Responsive: true,
		// Afficher les résultats sur une carte?
    ShowResultsOnMap: islgscreen,
    OnParcelShopSelected: function (data) {                                   
      $('#storeInfo').val(JSON.stringify(data));
      $('.store_pick_addr').empty();
      var store_addr = (data.Adresse2) ? data.Adresse1 +  ''  + data.Adresse2 : data.Adresse1
      $('.store_pick_addr').prepend('<div class="nom">'+data.Nom+'</div><div class="addr">'+store_addr+'</div><div class="city_zip">'+data.CP +  ' - '  + data.Ville+'</div>');
      $(document).on('click', '#zonewidget .PR-List-Item', function(){
        $('#zonewidget .remodal-confirm').removeClass('hide');
      });
        
      
    }
  });
  
  });

// Mondial Relay Code Ends
}

$(document).ready( function() {
  $( ".relay_link" ).on( "click", function() {
    handleCCOption();
  });
});
